
import { Component, Emit, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import MomentCard from './MomentCard.vue'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import type { WaterfallMoment } from '@xt/client/entities/course-v2/types.d'
import type { Tabs } from '@xt/client/entities/course-v2/waterfall'
import type { HomeworkOption, DairyOption } from '@xt/client/entities/course-v2/user-content'
import { Bind, Debounce } from 'lodash-decorators'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import InfiniteLoading, { StateChanger } from 'vue-infinite-loading'
import { EnumLoadResult } from '@xt/client/entities/course-v2/waterfall'
import { EnumSortType } from '@xt/client/enums/course/index'

@Observer
@Component({
  components: {
    MomentCard,
    UserContentPop,
    EmptyStatus,
    InfiniteLoading
  }
})
export default class WaterfallTab extends Vue {
  @Prop({ required: true }) courseId: string

  @Ref()
  userContentPop: {
    showPop: (options: HomeworkOption | DairyOption) => void
    hidePop: () => void
  }

  tab: Tabs = 'find'

  sortTypeList: Array<{
    label: string
    key: EnumSortType
  }> = [
    {
      label: '最热',
      key: EnumSortType.FinalSortScore
    },
    {
      label: '最新',
      key: EnumSortType.CreateTime
    },
    {
      label: '最多点赞',
      key: EnumSortType.LikeCount
    },
    {
      label: '最多评论',
      key: EnumSortType.CommentCount
    },
    {
      label: '最多收藏',
      key: EnumSortType.CollectCount
    }
  ]

  get EnumSortType() {
    return EnumSortType
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get GuideData() {
    return this.$store.$courseV2.GuideData
  }
  get WaterfallStore() {
    return this.$store.$courseV2.CourseWaterfall
  }

  // 滚动到二级锚点
  handleScrollToTop() {
    const el = document.getElementById('page-scroll-target-two')

    if (!el) return

    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }

  async handleChangeSortType({ key, domEvent }: { key: EnumSortType; domEvent: MouseEvent }) {
    domEvent.stopPropagation()

    if (this.WaterfallStore.sortType === key) return

    await this.WaterfallStore.changeSortType(key)

    this.handleScrollToTop()
  }

  async infiniteHandler($state: StateChanger) {
    const res = await this.WaterfallStore.loadMore(this.tab, this.courseId)

    if (res === EnumLoadResult.Cancel) {
      console.log('其他异常')
    }

    if (res === EnumLoadResult.Error) {
      $state.error()
    }

    if (res === EnumLoadResult.Loaded) {
      $state.loaded()
    }

    if (res === EnumLoadResult.Complete) {
      if (this.WaterfallStore.currentList.length > 0) {
        $state.loaded()
      }
      $state.complete()
    }
  }

  hideDairyPop() {
    this.userContentPop?.hidePop()
  }

  // 拉起作业日记详情弹窗
  showMockDairyPop(data) {
    // 加载mock数据
    this.$store.$courseV2.UserContent.loadMockContent(data)
    // 拉起内容弹窗
    this.userContentPop?.showPop({
      type: 'dairy',
      momentId: '1'
    })
  }

  async switchTab(tab: Tabs) {
    await this.WaterfallStore.switchTab(tab)
    this.tab = tab
    this.handleScrollToTop()
  }

  handleClickMoment(item: WaterfallMoment) {
    this.userContentPop?.showPop({
      type: 'dairy',
      momentId: item.id
    })
  }

  @Debounce(350, { leading: true, trailing: false })
  @Bind()
  async handleLikeMoment(item: WaterfallMoment) {
    try {
      await this.WaterfallStore.onLikeMoment(item)
      this.$message.success('点赞成功')
    } catch (e) {
      if (e instanceof Error) {
        this.$message.error(e.message)
      }
    }
  }

  handleRemoveSuccess(data: { type: 'homework'; homeworkId: number } | { type: 'dairy'; momentId: string }) {
    if (data.type === 'dairy' && data.momentId) {
      // 删除缓存的数据
      this.WaterfallStore.removeItem(data.momentId)
    }
  }

  handleLikeSuccess(data: { momentId: string }) {
    if (data.momentId) {
      this.WaterfallStore.likeItem(data.momentId)
    }
  }

  mounted() {}
  updated() {}
  destroyed() {
    // 清除数据
    this.WaterfallStore.reset()
  }
}
